var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitrePartenaire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 50",
    style: {
      enableBackground: "new 0 0 1000 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000182491295314743291150000002386962595695150494_);}\r\n\t.st2{fill:url(#SVGID_00000008833173705628913570000000328102260653032366_);}\r\n\t.st3{fill:url(#SVGID_00000164489549597452919220000013488506523957233587_);}\r\n\t.st4{fill:url(#SVGID_00000121958576146204267370000013930118576582888356_);}\r\n\t.st5{fill:url(#SVGID_00000060751691863012018670000010390398278757474705_);}\r\n\t.st6{fill:url(#SVGID_00000175314157522538236040000001233210048628708781_);}\r\n\t.st7{fill:url(#SVGID_00000051372719123232959190000013366961271602800291_);}\r\n\t.st8{fill:url(#SVGID_00000135674446316560954590000015175232197425128085_);}\r\n\t.st9{fill:url(#SVGID_00000102517908920346295660000006114243444949752963_);}\r\n\t.st10{fill:url(#SVGID_00000097470352516085742560000003153999960721276578_);}\r\n\t.st11{fill:url(#SVGID_00000114039127926568189480000005247647202049520802_);}\r\n\t.st12{fill:url(#SVGID_00000102510444358925309170000017646509197134177717_);}\r\n\t.st13{fill:url(#SVGID_00000019645363793031388580000000519164482880406154_);}\r\n\t.st14{fill:url(#SVGID_00000037689467093148147520000011452162584134140602_);}\r\n\t.st15{fill:url(#SVGID_00000047741969836883259140000001556523454157574018_);}\r\n\t.st16{fill:url(#SVGID_00000038406713738242821980000015992131520825955761_);}\r\n\t.st17{fill:url(#SVGID_00000164501577766768576000000009792439171424253829_);}\r\n\t.st18{fill:url(#SVGID_00000105415889769522437440000015421160327090015678_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.0554,
    y1: 27.2361,
    x2: 758.9309,
    y2: 4.9175,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.8,9.5h7.7v32.3h-7.7V9.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176020254140072412180000008862221754331738778_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.097,
    y1: 28.2096,
    x2: 758.9727,
    y2: 5.891,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176020254140072412180000008862221754331738778_)"
    },
    d: "M274.8,8.7v33.1h-7.4V8.7H274.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055698221778673957860000003326873141666985146_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.9413,
    y1: 24.5702,
    x2: 758.817,
    y2: 2.2516,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055698221778673957860000003326873141666985146_)"
    },
    d: "M278.3,38.8L282,34 c0.7,0.7,1.5,1.3,2.5,1.8s1.9,0.7,2.8,0.7c0.8,0,1.4-0.1,1.8-0.5c0.4-0.3,0.6-0.7,0.6-1.2s-0.3-0.9-0.8-1.3c-0.5-0.4-1.5-0.9-3-1.5 c-1.2-0.5-2.3-1.1-3.2-1.6c-0.9-0.6-1.6-1.1-2.1-1.7c-0.5-0.6-0.9-1.3-1.2-2c-0.2-0.7-0.4-1.5-0.4-2.4c0-1,0.2-1.9,0.6-2.7 c0.4-0.9,1-1.6,1.8-2.3s1.7-1.2,2.8-1.6c1.1-0.4,2.4-0.6,3.7-0.6c1.9,0,3.5,0.3,4.8,0.8c1.4,0.6,2.5,1.3,3.4,2.2l-3.6,4.8 c-0.6-0.6-1.3-1-2.1-1.4c-0.8-0.3-1.5-0.5-2.3-0.5c-0.6,0-1.1,0.1-1.5,0.3s-0.6,0.5-0.6,0.9s0.2,0.7,0.7,1s1.3,0.6,2.5,1.1 c1.3,0.5,2.3,1.1,3.3,1.6c0.9,0.5,1.7,1.1,2.3,1.7c0.6,0.6,1.1,1.3,1.4,2c0.3,0.8,0.4,1.6,0.4,2.6c0,1.1-0.2,2.1-0.7,3.1 c-0.4,1-1.1,1.8-1.9,2.5c-0.8,0.7-1.8,1.3-2.9,1.7c-1.1,0.4-2.4,0.6-3.8,0.6c-2.1,0-3.9-0.3-5.4-0.9 C280.7,40.9,279.4,40,278.3,38.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150073679943813008390000014582546113419119518_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.0064,
    y1: 26.0909,
    x2: 758.882,
    y2: 3.7723,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150073679943813008390000014582546113419119518_)"
    },
    d: "M313.5,41.8V17.9h7.4v2.4 c1.1-1,2.1-1.7,3.2-2.3c1.1-0.5,2.4-0.8,3.9-0.8c1.1,0,2.2,0.2,3.2,0.6c1,0.4,1.8,1,2.5,1.7s1.3,1.6,1.7,2.7 c0.4,1.1,0.6,2.3,0.6,3.7v15.8h-7.4V30.3c0-2-0.2-3.5-0.7-4.6c-0.4-1.1-1.4-1.6-2.8-1.6c-1.3,0-2.3,0.5-3.1,1.5 c-0.8,1-1.1,2.5-1.1,4.5v11.7H313.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122704053729903389960000009315670758844825788_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.0501,
    y1: 27.1121,
    x2: 758.9256,
    y2: 4.7935,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122704053729903389960000009315670758844825788_)"
    },
    d: "M340.2,29.8c0-1.9,0.3-3.6,1-5.1 c0.6-1.5,1.5-2.9,2.7-4c1.1-1.1,2.5-2,4-2.6s3.2-0.9,5-0.9s3.5,0.3,5,0.9c1.5,0.6,2.9,1.5,4,2.6s2,2.4,2.7,4c0.6,1.5,1,3.2,1,5.1 c0,1.8-0.3,3.4-0.9,5c-0.6,1.5-1.5,2.9-2.6,4c-1.1,1.1-2.5,2-4,2.7c-1.6,0.6-3.3,1-5.1,1c-1.8,0-3.5-0.3-5.1-1 c-1.6-0.6-2.9-1.5-4-2.7c-1.1-1.1-2-2.5-2.6-4C340.5,33.3,340.2,31.6,340.2,29.8z M347.8,29.9c0,1.7,0.5,3.1,1.4,4.1 s2.2,1.5,3.7,1.5s2.8-0.5,3.7-1.5c0.9-1,1.4-2.3,1.4-4.1c0-1.6-0.5-2.9-1.4-4s-2.2-1.6-3.8-1.6c-1.6,0-2.8,0.5-3.8,1.6 C348.3,27,347.8,28.3,347.8,29.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036248158562356972040000011527129881894822823_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.0986,
    y1: 28.2459,
    x2: 758.9741,
    y2: 5.9273,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036248158562356972040000011527129881894822823_)"
    },
    d: "M370.1,17.9h7.4V30c0,3.8,1.2,5.6,3.6,5.6 c1.4,0,2.3-0.5,2.9-1.4s0.8-2.3,0.8-4.1V17.9h7.5v12.4c0,4.2-1,7.2-2.9,9.2c-2,2-4.7,2.9-8.2,2.9c-3.6,0-6.4-0.9-8.3-2.8 s-2.8-4.9-2.8-9V17.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119100540473510676210000012222922378586513078_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.1562,
    y1: 29.5946,
    x2: 759.0317,
    y2: 7.276,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119100540473510676210000012222922378586513078_)"
    },
    d: "M396,38.8l3.7-4.8 c0.7,0.7,1.5,1.3,2.5,1.8s1.9,0.7,2.8,0.7c0.8,0,1.4-0.1,1.8-0.5c0.4-0.3,0.6-0.7,0.6-1.2s-0.3-0.9-0.8-1.3c-0.5-0.4-1.5-0.9-3-1.5 c-1.2-0.5-2.3-1.1-3.2-1.6c-0.9-0.6-1.6-1.1-2.1-1.7c-0.5-0.6-0.9-1.3-1.2-2c-0.2-0.7-0.4-1.5-0.4-2.4c0-1,0.2-1.9,0.6-2.7 c0.4-0.9,1-1.6,1.8-2.3s1.7-1.2,2.8-1.6c1.1-0.4,2.4-0.6,3.7-0.6c1.9,0,3.5,0.3,4.8,0.8c1.4,0.6,2.5,1.3,3.4,2.2l-3.6,4.8 c-0.6-0.6-1.3-1-2.1-1.4c-0.8-0.3-1.5-0.5-2.3-0.5c-0.6,0-1.1,0.1-1.5,0.3s-0.6,0.5-0.6,0.9s0.2,0.7,0.7,1s1.3,0.6,2.5,1.1 c1.3,0.5,2.3,1.1,3.3,1.6c0.9,0.5,1.7,1.1,2.3,1.7c0.6,0.6,1.1,1.3,1.4,2c0.3,0.8,0.4,1.6,0.4,2.6c0,1.1-0.2,2.1-0.7,3.1 c-0.4,1-1.1,1.8-1.9,2.5c-0.8,0.7-1.8,1.3-2.9,1.7c-1.1,0.4-2.4,0.6-3.8,0.6c-2.1,0-3.9-0.3-5.4-0.9C398.4,40.9,397.1,40,396,38.8z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119100720408880484850000009560626540353033139_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.4112,
    y1: 35.5578,
    x2: 759.2868,
    y2: 13.2391,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119100720408880484850000009560626540353033139_)"
    },
    d: "M429,17.9h2.4v-1.3c0-1.4,0.1-2.7,0.3-3.8 c0.2-1.1,0.6-2,1.1-2.7s1.3-1.2,2.2-1.6c0.9-0.4,2-0.5,3.4-0.5c1,0,1.9,0.1,2.7,0.3c0.8,0.2,1.4,0.4,1.9,0.7v5.4 c-0.3-0.1-0.7-0.2-1-0.3c-0.4-0.1-0.8-0.1-1.2-0.1c-0.7,0-1.2,0.2-1.5,0.5c-0.3,0.4-0.5,1.1-0.5,2.2v1.2h3.9v6.5h-3.9v17.4h-7.4 V24.4H429V17.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067929499175115907380000017790529445437503906_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.2411,
    y1: 31.5773,
    x2: 759.1166,
    y2: 9.2587,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067929499175115907380000017790529445437503906_)"
    },
    d: "M444.8,29.8c0-1.9,0.3-3.6,1-5.1 c0.6-1.5,1.5-2.9,2.7-4c1.1-1.1,2.5-2,4-2.6s3.2-0.9,5-0.9s3.5,0.3,5,0.9c1.5,0.6,2.9,1.5,4,2.6s2,2.4,2.7,4c0.6,1.5,1,3.2,1,5.1 c0,1.8-0.3,3.4-0.9,5c-0.6,1.5-1.5,2.9-2.6,4c-1.1,1.1-2.5,2-4,2.7c-1.6,0.6-3.3,1-5.1,1c-1.8,0-3.5-0.3-5.1-1 c-1.6-0.6-2.9-1.5-4-2.7c-1.1-1.1-2-2.5-2.6-4C445.2,33.3,444.8,31.6,444.8,29.8z M452.4,29.9c0,1.7,0.5,3.1,1.4,4.1 s2.2,1.5,3.7,1.5s2.8-0.5,3.7-1.5c0.9-1,1.4-2.3,1.4-4.1c0-1.6-0.5-2.9-1.4-4s-2.2-1.6-3.8-1.6c-1.6,0-2.8,0.5-3.8,1.6 C452.9,27,452.4,28.3,452.4,29.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176037302130660405090000010295050323347224505_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.3007,
    y1: 32.9723,
    x2: 759.1762,
    y2: 10.6536,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176037302130660405090000010295050323347224505_)"
    },
    d: "M474.7,41.8V17.9h7.4v2.4 c1.1-1,2.1-1.7,3.2-2.3c1.1-0.5,2.4-0.8,3.9-0.8c1.1,0,2.2,0.2,3.2,0.6c1,0.4,1.8,1,2.5,1.7s1.3,1.6,1.7,2.7 c0.4,1.1,0.6,2.3,0.6,3.7v15.8h-7.4V30.3c0-2-0.2-3.5-0.7-4.6c-0.4-1.1-1.4-1.6-2.8-1.6c-1.3,0-2.3,0.5-3.1,1.5 c-0.7,1-1.1,2.5-1.1,4.5v11.7H474.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042722371551988340030000000256647967431518124_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.5194,
    y1: 38.0865,
    x2: 759.395,
    y2: 15.7678,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042722371551988340030000000256647967431518124_)"
    },
    d: "M500.2,17.9h3.2V9.1h7.5v8.8h3.6v6.6h-3.6 v17.3h-7.5V24.5h-3.2V17.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177461041698086118280000007271088026906393515_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.3903,
    y1: 35.0678,
    x2: 759.2657,
    y2: 12.7492,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177461041698086118280000007271088026906393515_)"
    },
    d: "M528.7,29.9c0-1.8,0.3-3.5,1-5.1 c0.6-1.5,1.5-2.9,2.7-4s2.5-2,4.1-2.6s3.4-0.9,5.3-0.9c1.2,0,2.4,0.1,3.5,0.4c1.1,0.3,2.1,0.6,2.9,1c0.9,0.4,1.6,0.9,2.3,1.5 s1.2,1.1,1.6,1.7l-5,4.7c-0.7-0.7-1.4-1.2-2.3-1.6c-0.8-0.4-1.9-0.6-3.1-0.6c-1.7,0-3.1,0.5-4.1,1.6s-1.5,2.4-1.5,4 c0,1.7,0.5,3,1.5,4s2.4,1.5,4.1,1.5c1.1,0,2.1-0.2,3-0.6c0.9-0.4,1.7-0.9,2.3-1.6l5,4.9c-1.1,1.2-2.5,2.2-4.2,3.1 c-1.8,0.8-3.8,1.3-6.3,1.3c-2,0-3.7-0.3-5.3-0.9s-3-1.5-4.1-2.6s-2-2.4-2.6-4C529,33.4,528.7,31.8,528.7,29.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094620285378493919060000012017462638253289615_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.4407,
    y1: 36.2473,
    x2: 759.3163,
    y2: 13.9287,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094620285378493919060000012017462638253289615_)"
    },
    d: "M554.2,29.8c0-1.9,0.3-3.6,1-5.1 c0.6-1.5,1.5-2.9,2.7-4c1.1-1.1,2.5-2,4-2.6s3.2-0.9,5-0.9s3.5,0.3,5,0.9c1.5,0.6,2.9,1.5,4,2.6s2,2.4,2.7,4c0.6,1.5,1,3.2,1,5.1 c0,1.8-0.3,3.4-0.9,5c-0.6,1.5-1.5,2.9-2.6,4c-1.1,1.1-2.5,2-4,2.7c-1.6,0.6-3.3,1-5.1,1s-3.5-0.3-5.1-1c-1.6-0.6-2.9-1.5-4-2.7 c-1.1-1.1-2-2.5-2.6-4C554.5,33.3,554.2,31.6,554.2,29.8z M561.8,29.9c0,1.7,0.5,3.1,1.4,4.1s2.2,1.5,3.7,1.5s2.8-0.5,3.7-1.5 s1.4-2.3,1.4-4.1c0-1.6-0.5-2.9-1.4-4s-2.2-1.6-3.8-1.6s-2.8,0.5-3.8,1.6C562.2,27,561.8,28.3,561.8,29.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160891470300512773450000005466491607253261191_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.5004,
    y1: 37.6423,
    x2: 759.376,
    y2: 15.3237,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160891470300512773450000005466491607253261191_)"
    },
    d: "M584.1,41.8V17.9h7.4v2.4 c1.1-1,2.1-1.7,3.2-2.3c1.1-0.5,2.4-0.8,3.9-0.8c1.1,0,2.2,0.2,3.2,0.6c1,0.4,1.8,1,2.5,1.7s1.3,1.6,1.7,2.7 c0.4,1.1,0.6,2.3,0.6,3.7v15.8h-7.4V30.3c0-2-0.2-3.5-0.7-4.6c-0.4-1.1-1.4-1.6-2.8-1.6c-1.3,0-2.3,0.5-3.1,1.5 c-0.7,1-1.1,2.5-1.1,4.5v11.7H584.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181784848988270279580000012877238688641790617_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.7426,
    y1: 43.3058,
    x2: 759.6182,
    y2: 20.9872,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181784848988270279580000012877238688641790617_)"
    },
    d: "M609.7,24.4v-6.5h2.4c0-1,0.1-2,0.4-3 c0.3-1,0.7-1.9,1.3-2.6c0.8-1.4,2-2.4,3.4-3.1c1.5-0.7,3.4-1.1,5.6-1.1c3.2,0,5.6,0.7,7.3,2c1.7,1.4,2.8,3.2,3.2,5.4h-7.7 c-0.6-1-1.5-1.5-2.7-1.5c-1.3,0-2.2,0.4-2.6,1.1c-0.5,0.8-0.7,1.7-0.7,2.8h3.6v6.5h-3.6v17.4h-7.4V24.4H609.7z M625.8,41.8V17.9 h7.4v23.9H625.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157307834194237622820000005055343282982259360_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.5864,
    y1: 39.6526,
    x2: 759.4619,
    y2: 17.334,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157307834194237622820000005055343282982259360_)"
    },
    d: "M637.1,29.9c0-2,0.3-3.8,0.9-5.4 c0.6-1.6,1.4-2.9,2.3-4c1-1.1,2.1-1.9,3.4-2.4c1.3-0.6,2.6-0.8,4.1-0.8c1.7,0,3,0.3,4.2,0.9c1.1,0.6,2.1,1.3,2.9,2.3V18h7.4v23.9 h-7.4v-2.5c-0.9,1-1.9,1.7-3,2.3c-1.1,0.6-2.5,0.8-4,0.8c-1.4,0-2.7-0.3-4-0.8c-1.3-0.6-2.4-1.4-3.4-2.4c-1-1.1-1.8-2.4-2.4-3.9 C637.4,33.7,637.1,31.9,637.1,29.9z M649.9,35.5c1.5,0,2.8-0.5,3.7-1.6c1-1,1.4-2.4,1.4-4.2c0-1.7-0.5-3.1-1.5-4.1 s-2.2-1.5-3.8-1.5s-2.9,0.5-3.8,1.6c-0.9,1.1-1.4,2.4-1.4,4.1c0,1.7,0.5,3.1,1.5,4.1C647.1,35,648.4,35.5,649.9,35.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003077919169273005630000012902133087843592105_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.6532,
    y1: 41.2153,
    x2: 759.5287,
    y2: 18.8967,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003077919169273005630000012902133087843592105_)"
    },
    d: "M667.8,41.8V17.9h7.4v2.4 c1.1-1,2.1-1.7,3.2-2.3c1.1-0.5,2.4-0.8,3.9-0.8c1.1,0,2.2,0.2,3.2,0.6c1,0.4,1.8,1,2.5,1.7s1.3,1.6,1.7,2.7 c0.4,1.1,0.6,2.3,0.6,3.7v15.8h-7.4V30.3c0-2-0.2-3.5-0.7-4.6c-0.4-1.1-1.4-1.6-2.8-1.6c-1.3,0-2.3,0.5-3.1,1.5 c-0.7,1-1.1,2.5-1.1,4.5v11.7H667.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114771559007932504010000014994953817701672375_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.6931,
    y1: 42.1497,
    x2: 759.5688,
    y2: 19.8311,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114771559007932504010000014994953817701672375_)"
    },
    d: "M694.6,29.9c0-1.8,0.3-3.5,1-5.1 c0.6-1.5,1.5-2.9,2.7-4s2.5-2,4.1-2.6s3.4-0.9,5.3-0.9c1.2,0,2.4,0.1,3.5,0.4c1.1,0.3,2.1,0.6,2.9,1c0.9,0.4,1.6,0.9,2.3,1.5 s1.2,1.1,1.6,1.7l-5,4.7c-0.7-0.7-1.4-1.2-2.3-1.6c-0.8-0.4-1.9-0.6-3.1-0.6c-1.7,0-3.1,0.5-4.1,1.6s-1.5,2.4-1.5,4 c0,1.7,0.5,3,1.5,4s2.4,1.5,4.1,1.5c1.1,0,2.1-0.2,3-0.6c0.9-0.4,1.7-0.9,2.3-1.6l5,4.9c-1.1,1.2-2.5,2.2-4.2,3.1 c-1.8,0.8-3.8,1.3-6.3,1.3c-2,0-3.7-0.3-5.3-0.9s-3-1.5-4.1-2.6s-2-2.4-2.6-4C694.9,33.4,694.6,31.8,694.6,29.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001627683475781931510000000669205547734661029_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.737,
    y1: 43.1737,
    x2: 759.6125,
    y2: 20.8551,
    gradientTransform: "matrix(1 0 0 -1 0 52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01667357,
    style: {
      stopColor: "#66AEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006388"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001627683475781931510000000669205547734661029_)"
    },
    d: "M720.1,29.8c0-1.6,0.3-3.2,0.9-4.7 c0.6-1.5,1.4-2.9,2.5-4c1.1-1.2,2.4-2.1,3.9-2.8s3.3-1,5.2-1c2,0,3.7,0.3,5.3,1c1.6,0.6,2.9,1.6,4.1,2.7c1.1,1.2,2,2.6,2.6,4.2 c0.6,1.6,0.9,3.4,0.9,5.3c0,0.3,0,0.6,0,0.9c0,0.3,0,0.5-0.1,0.8h-18.1c0.3,1.4,0.9,2.5,1.9,3.3c1,0.7,2.3,1.1,3.7,1.1 c1.1,0,2.2-0.2,3-0.5c0.9-0.4,1.8-0.9,2.7-1.7L744,38c-1.1,1.4-2.6,2.5-4.5,3.4c-1.8,0.9-4.1,1.3-6.7,1.3c-1.9,0-3.6-0.3-5.2-0.9 c-1.6-0.6-2.9-1.5-4-2.6s-2-2.5-2.6-4C720.4,33.3,720.1,31.6,720.1,29.8z M727.5,26.9h10.6c-0.3-1.3-0.9-2.2-1.9-2.9s-2.2-1-3.5-1 s-2.3,0.3-3.3,1S727.9,25.6,727.5,26.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitrePartenaire);
export default __webpack_public_path__ + "static/media/titrePartenaire.df7501699e20284ef7a5405937f0d4d6.svg";
export { ForwardRef as ReactComponent };